/**
 * Module-level store for service extras/products selections.
 *
 * BookEventForm writes here (setPendingServiceSelections) just before calling
 * Cal's native onSubmit(). useBookings.ts reads here (consumePendingServiceSelections)
 * in the createBookingMutation onSuccess callback to fire the extras-persistence
 * side-request after the Cal booking is created.
 *
 * This is safe because the user is on a single booking page at a time and the
 * values are consumed (cleared) immediately after the booking succeeds.
 */

export type PendingExtra = {
  id: number;
  name: string;
  quantity: number;
  unitPrice: number;
};

export type PendingProduct = {
  id: number;
  name: string;
  sku?: string;
  quantity: number;
  unitPrice: number;
};

let _extras: PendingExtra[] = [];
let _products: PendingProduct[] = [];
let _eventTypeId: number | null = null;

export function setPendingServiceSelections(
  eventTypeId: number | null,
  extras: PendingExtra[],
  products: PendingProduct[]
) {
  _eventTypeId = eventTypeId;
  _extras = [...extras];
  _products = [...products];
}

export function consumePendingServiceSelections(): {
  eventTypeId: number | null;
  extras: PendingExtra[];
  products: PendingProduct[];
} {
  const result = { eventTypeId: _eventTypeId, extras: _extras, products: _products };
  _eventTypeId = null;
  _extras = [];
  _products = [];
  return result;
}
